module.exports = __webpack_public_path__ + "static/media/sam.16fd5da4.png";